import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo";
import { ORGANIZATION_LD, LOCAL_BUSINESS_LD, FAQ_LD, ABOUT_BREADCRUMB_LD } from "@/lib/ld/about";

export const Route = createFileRoute("/_app/about")({
  head: () =>
    buildHead({
      title: "About LohaLink — B2B Scrap Metal Marketplace India",
      description:
        "LohaLink is India's verified B2B scrap metal marketplace — GST-verified suppliers, RBI-grade escrow and AI grading for HMS, sponge iron and MS billets.",
      canonical: "/about",
      jsonLd: [ORGANIZATION_LD, LOCAL_BUSINESS_LD, FAQ_LD, ABOUT_BREADCRUMB_LD],
    }),
  component: lazyRouteComponent(() => import("@/pages/About")),
});
